import React from 'react';
import { Link } from 'react-router-dom';
import { CompassIcon } from 'lucide-react';
import { EmptyState } from '../components/EmptyState';
import { buttonClass } from '../utils/styles';
export function NotFound() {
  return <div className="pt-24" data-id="element-438" data-mp="10534zxah75sw">
      <EmptyState icon={CompassIcon} headingLevel="h1" title="Esta página no existe" description="Puede que la obra se haya retirado o que el enlace no sea correcto." action={<>
            <Link to="/" className={buttonClass('primary', 'md')} data-id="element-440" data-mp="1f2ltcyj8rgzt">
              Ir al inicio
            </Link>
            <Link to="/buscar" className={buttonClass('secondary', 'md')} data-id="element-441" data-mp="1jtlu6evhej7l">
              Buscar
            </Link>
          </>} data-id="element-439" data-mp="107z43oy280ix" />
    </div>;
}